/* globals $ */
import Masonry from '../vendors/masonry.min';

import Component from './component';

/* eslint-disable react/prefer-stateless-function, react/sort-comp */

const defaults = {
  itemSelector: '.grid-item',
  columnWidth: null,
  horizontalOrder: false,
  percentPosition: true,
  gutter: 32,
  initLayout: false,
  transitionDuration: '0.2s',
  stamp: '.grid-sidebar',
};

export default class MasonryGrid extends Component {

  constructor($context, options) {
    super(defaults, options);

    this.$context = $context;

    this.settings.columnWidth = this.$context[0].querySelector('.grid-sizer');

    this.masonry = null;
    this.isMasonryReady = false;

    this.init();
  }

  init() {
    this.initMasonry();
  }

  initMasonry() {
    this.toggleMasonry();
    window.addEventListener('resize', this.toggleMasonry.bind(this));
  }

  toggleMasonry() {
    const ww = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );

    if (ww >= 640) {
      if (!this.masonry) {
        this.masonry = new Masonry(this.$context[0], this.settings);
      }

      if (!this.isMasonryReady) {
        this.masonry.layout();
        this.masonry.$element.addClass('masonry-init');
        this.isMasonryReady = true;
        this.fire('changed');
      }
    } else if (this.isMasonryReady) {
      this.isMasonryReady = false;
      this.fire('changed');
      this.masonry.destroy();
      this.masonry.$element.removeClass('masonry-init');
    }
  }

  refresh() {
    if (this.isMasonryReady) {
      this.masonry.layout();
    }
  }

  reload() {
    if (this.isMasonryReady) {
      this.masonry.layout();
      this.masonry.reloadItems();
    }
  }

  prepended(items) {
    if (this.isMasonryReady) {
      this.masonry.prepended(items);
      this.stampade(items);
    }
  }

  appended(items) {
    if (this.isMasonryReady) {
      this.masonry.appended(items);
      this.stampade(items);
    }
  }

  stampade(items) {
    const $stamps = items.filter('.grid-sidebar');

    if ($stamps.length) {
      this.masonry.stamp($stamps);
    }
  }

  static initialize($context = $(document.body), options = {}) {
    return super.initialize('.js-masonry-grid', MasonryGrid, 'MasonryGrid', $context, options);
  }

}



// WEBPACK FOOTER //
// ./front/bankomania/js/components/masonry-grid.js